import { render, staticRenderFns } from "./CdrDashboard.vue?vue&type=template&id=7961bba8&scoped=true"
import script from "./CdrDashboard.vue?vue&type=script&lang=js"
export * from "./CdrDashboard.vue?vue&type=script&lang=js"
import style0 from "./CdrDashboard.vue?vue&type=style&index=0&id=7961bba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7961bba8",
  null
  
)

export default component.exports